import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'

import {
  REQUEST_PROFILE_TAB_CHATS_ORDER,
  REQUEST_PROFILE_TAB_CHATS_ORDER_REVERSED,
  REQUEST_PROFILE_TAB_CHATS_PERMISSION_KEY,
  REQUEST_PROFILE_TAB_CHATS_PRIVATE,
  REQUEST_PROFILE_TAB_CHATS_PUBLIC,
  REQUEST_PROFILE_TAB_CHATS_SUB_TAB_QA_NAME,
  REQUEST_PROFILE_TAB_CHATS_SUB_TABS_VISIBLE_COUNT,
  REQUEST_PROFILE_TAB_CHATS_TITLE_KEY,
} from './RequestProfileTabChats.constants'

export function getIsRequestProfileTabChatsSubTabsVisible(items) {
  return items.length === REQUEST_PROFILE_TAB_CHATS_SUB_TABS_VISIBLE_COUNT
}

export function getRequestProfileTabChatsOrder(isReversed) {
  return isReversed
    ? REQUEST_PROFILE_TAB_CHATS_ORDER_REVERSED
    : REQUEST_PROFILE_TAB_CHATS_ORDER
}

export function getRequestProfileTabChatsToggleItemLabel({ count, text }) {
  return count ? `${text} (${count})` : text
}

export function getRequestProfileTabChatsSubTabQaName(item) {
  return REQUEST_PROFILE_TAB_CHATS_SUB_TAB_QA_NAME[item.value]
}

export function getRequestProfileTabChatsToggleItems({
  allowedSubTabs,
  counters,
  t,
}) {
  return allowedSubTabs.map(value => {
    const tabCounters = counters?.[value] || EMPTY_OBJECT

    return {
      count: tabCounters.total,
      text: t(REQUEST_PROFILE_TAB_CHATS_TITLE_KEY[value]),
      unreadCount: tabCounters.unread,
      value,
    }
  })
}

// The sub-tab to open on entry when the URL has no `?sub=`: the single sub-tab
// with unread messages, or `undefined` when zero or several are unread (the
// caller then falls back to the first sub-tab).
export function getRequestProfileTabChatsPreferredSubTab({
  allowedSubTabs,
  counters,
}) {
  const unreadSubTabs = allowedSubTabs.filter(
    value => (counters?.[value]?.unread || 0) > 0
  )

  return unreadSubTabs.length === 1 ? unreadSubTabs[0] : undefined
}

export function getRequestProfileTabChatsChatroomUuid({
  activeSubTab,
  requestData,
}) {
  return activeSubTab === REQUEST_PROFILE_TAB_CHATS_PRIVATE
    ? requestData?.privateChatroom
    : requestData?.publicChatroom
}

export function getIsRequestProfileTabChatsPrivate(activeSubTab) {
  return activeSubTab === REQUEST_PROFILE_TAB_CHATS_PRIVATE
}

export function getIsRequestProfileTabChatsPublic(activeSubTab) {
  return activeSubTab === REQUEST_PROFILE_TAB_CHATS_PUBLIC
}

export function getRequestProfileTabChatsAllowedSubTabs({
  requestData,
  subTabsOrder,
}) {
  const permissions = requestData?.permissions

  if (!permissions) {
    return EMPTY_LIST
  }

  return subTabsOrder.filter(value => {
    const permissionKey = REQUEST_PROFILE_TAB_CHATS_PERMISSION_KEY[value]

    return Boolean(permissions[permissionKey])
  })
}
